import { render, staticRenderFns } from "./KSelect.vue?vue&type=template&id=9b456c90&"
import script from "./KSelect.vue?vue&type=script&lang=js&"
export * from "./KSelect.vue?vue&type=script&lang=js&"
import style0 from "./KSelect.vue?vue&type=style&index=0&id=9b456c90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports